export function initStructureObject() {
    return (
        {
            id: null,
            address: "",
            ape_code: "",
            city: "",
            plm_number: "",
            postal_code: "",
            siret: null,
            trade_name: ""
        }
    )
}

export function buildStructureFormDataBuilder(structure) {    
    const formData = new FormData();

    if (structure.id) {
        formData.append('structure[id]', structure.id);
    }
    
    formData.append(`structure[address]`, structure.address);
    formData.append(`structure[ape_code]`, structure.ape_code);
    formData.append(`structure[city]`, structure.city);
    formData.append(`structure[plm_number]`, structure.plm_number);
    formData.append(`structure[postal_code]`, structure.postal_code);
    formData.append(`structure[trade_name]`, structure.trade_name);

    if (structure.siret)
        formData.append(`structure[siret]`, structure.siret);

    if (structure.customer_id)
        formData.append(`structure[customer_id]`, structure.customer_id);

    return formData;
}
